import React, { useState, useEffect } from "react";
import {
	GoogleMap,
	useLoadScript,
	Marker,
	InfoWindow,
} from "@react-google-maps/api";
import axios from "axios";
import { toast } from "react-toastify";

const libraries = ["places"];
const mapContainerStyle = {
	width: "100%",
	height: "50vh",
};

const defaultCenter = {
	lat: -7.7429408,
	lng: 110.364977,
};

const Maps = () => {
	const { isLoaded, loadError } = useLoadScript({
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
		libraries,
	});

	const [contact, setContact] = useState({
		school_name: "Jogja Madrasah Digital",
		address: "7947+RX Sendangadi, Kabupaten Sleman, Daerah Istimewa Yogyakarta",
		link_maps: "https://maps.app.goo.gl/piupSHnaFoHofU53A",
		coordinates: "",
	});

	const [showInfoWindow, setShowInfoWindow] = useState(false);

	useEffect(() => {
		const fetchKontak = async () => {
			try {
				const response = await axios.get(`/api_w/medsos`, {
					headers: {
						db_name: process.env.REACT_APP_DB_NAME,
					},
				});
				const kontak = response.data.data[0];
				setContact(kontak);
			} catch (error) {
				toast.error(error.response?.data?.message || error.message);
			}
		};
		fetchKontak();
	}, []);

	if (loadError) {
		return <div>Error loading maps</div>;
	}

	if (!isLoaded) {
		return <div>Loading maps</div>;
	}

	let coordinates = contact.coordinates || defaultCenter;
	if (contact.coordinates) {
		const [lat, lng] = contact.coordinates.split(",").map(Number);
		coordinates = { lat, lng };
	}

	const handleMarkerClick = () => {
		setShowInfoWindow(true);
	};

	const handleInfoWindowClose = () => {
		setShowInfoWindow(false);
	};

	return (
		<div>
			<GoogleMap
				mapContainerStyle={mapContainerStyle}
				zoom={14}
				center={coordinates}
				options={{
					zoomControl: true,
				}}
			>
				<Marker position={coordinates} onClick={handleMarkerClick} />
				{showInfoWindow && (
					<InfoWindow
						position={coordinates}
						onCloseClick={handleInfoWindowClose}
					>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "justify",
							}}
						>
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									alignItems: "left",
								}}
							>
								<div
									className="text-left font-bold"
									style={{ marginRight: "auto" }}
								>
									{contact.school_name || "Jogja Madrasah Digital"}
								</div>
							</div>
							<br />
							<span
								className="w-40"
								style={{ display: "inline-block", textOverflow: "ellipsis" }}
							>
								{contact.address ||
									"Jl. Sukonandi No.8, Semaki, Kec. Umbulharjo, Kota Yogyakarta, Daerah Istimewa Yogyakarta, 55166"}
							</span>
							<br />
							<a
								href={
									contact.link_maps ||
									"https://maps.app.goo.gl/tZnXmodv7gHNoG9V9"
								}
								target="_blank"
								rel="noopener noreferrer"
								className="text-blue-700"
							>
								View on Google Maps
							</a>
						</div>
					</InfoWindow>
				)}
			</GoogleMap>
		</div>
	);
};

export default Maps;
